export const UPDATE_BILL_START = 'UPDATE_BILL_START';
export const UPDATE_BILL_SUCCESS = 'UPDATE_BILL_SUCCESS';
export const UPDATE_BILL_ERROR = 'UPDATE_BILL_ERROR';
